import React, { useState } from 'react';
import { Card, Typography, Button } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import Recalculation from '../calc/Recalculation';

interface RecalculationCardProps {
  client: { id: string; name?: string; token: string; permissions: string[] };
  year?: number | null;
}

const RecalculationCard: React.FC<RecalculationCardProps> = ({ client, year }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Card
      title={
        <Typography.Title
          level={3}
          style={{ margin: 0, cursor: 'pointer' }}
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          Bericht neu berechnen
        </Typography.Title>
      }
      extra={
        <Button
          type="text"
          icon={isExpanded ? <UpOutlined /> : <DownOutlined />}
          onClick={() => setIsExpanded((prev) => !prev)}
        />
      }
      style={{ boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)' }}
    >
      {isExpanded ? (
        <Recalculation client={client} showTitle={false} yearDefault={year ?? undefined} />
      ) : (
        <div style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => setIsExpanded(true)}>
          <Typography.Paragraph type="secondary">
            Klicken Sie hier, um den Bericht neu zu berechnen.
          </Typography.Paragraph>
        </div>
      )}
    </Card>
  );
};

export default RecalculationCard;
